<template>
  <SidebarComponent />
  <div class="dashboard-layout">
    <div class="content-container">
      <div class="card-container">
        <div class="titolo-card">
          <h1>Elenco Prodotti</h1>
        </div>

        <!-- TOOLBAR -->
        <div class="toolbar">
          <input v-model="search" class="search" type="text" placeholder="Cerca per nome o SKU…" />
          <select v-model="categoryFilter" class="select">
            <option value="">Tutte le categorie</option>
            <option v-for="c in categoryOptions" :key="c" :value="c">{{ c }}</option>
          </select>
          <select v-model="sortKey" class="select">
            <option value="name">Ordina per: Nome</option>
            <option value="updatedAt">Ordina per: Aggiornamento</option>
            <option value="price">Ordina per: Prezzo</option>
          </select>

          <button class="add-product-button" @click="openForm('create')">Nuovo prodotto</button>
        </div>

        <!-- LISTA PRODOTTI -->
        <div v-for="p in filteredAndSorted" :key="p.id" class="card-black-orders">
          <div class="card-header2" @click="toggleAccordion(p.id)">
            <div class="icon-column"><span class="material-icons">inventory_2</span></div>
            <div class="text-column">
              <div class="header-text">{{ p.name }}</div>
              <div class="text-sub">
                <span class="badge badge-cat">{{ p.category || '—' }}</span>
                <span class="sku" v-if="p.sku">SKU: {{ p.sku }}</span>
              </div>
            </div>
            <div class="price-column">
              <div class="price">{{ formatPrice(p.price) }}</div>
              <div class="muted">{{ p.updatedAt ? 'Upd: ' + formatDate(p.updatedAt) : '' }}</div>
            </div>
            <div class="icon-column-right">
              <span class="material-icons">{{ currentAccordion === p.id ? 'expand_less' : 'expand_more' }}</span>
            </div>
          </div>

          <div v-if="currentAccordion === p.id" class="product-details">
            <div class="grid">
                            <div class="kv"><span class="k">Durata (mesi)</span><span class="v">{{ p.duration_months ?? 0 }}</span></div>

              <div class="kv"><span class="k">Programmi</span><span class="v">{{ p.program_count ?? 0 }}</span></div>
              <div class="kv"><span class="k">Coaching qty</span><span class="v">{{ p.coaching_quantity ?? 0 }}</span></div>
                           <div class="kv"><span class="k">Cons. Tecniche</span><span class="v">{{ p.cons_tecniche ?? 0 }}</span></div>
              <div class="kv"><span class="k">Cons. Nutrizionali</span><span class="v">{{ p.cons_nutrizionali ?? 0 }}</span></div>

              <div class="kv"><span class="k">PT qty</span><span class="v">{{ p.pt_quantity ?? 0 }}</span></div>


            </div>

            <!-- Azioni -->
            <div class="actions">
              <button class="btn ghost staff-button-positive" @click.stop="openForm('edit', p)">Modifica</button>
              <button class="btn danger staff-button-danger" @click.stop="deleteProduct(p.id)">Elimina</button>
            </div>
          </div>
        </div>

        <!-- MODALE CREAZIONE / MODIFICA -->
        <div v-if="showForm" class="modal">
          <div class="dialog">
            <form @submit.prevent="saveProduct">
              <h3 class="modal-title">{{ formMode === 'create' ? 'Nuovo prodotto' : 'Modifica prodotto' }}</h3>

              <div class="form-grid">
                <div class="field">
                  <label>Nome *</label>
                  <input v-model.trim="formProduct.name" required />
                </div>
                <div class="field">
                  <label>SKU</label>
                  <input v-model.trim="formProduct.sku" />
                </div>
                <div class="field">
                  <label>Prezzo</label>
                  <input v-model.number="formProduct.price" type="number" step="0.01" />
                </div>
                <div class="field">
                  <label>Categoria</label>
                  <select v-model="formProduct.category">
                    <option v-for="c in categoryOptions" :key="c" :value="c">{{ c }}</option>
                  </select>
                </div>
                <div class="field">
                  <label>Durata (mesi)</label>
                  <input v-model.number="formProduct.duration_months" type="number" min="0" />
                </div>
                <div class="field">
                  <label>Programmi</label>
                  <input v-model.number="formProduct.program_count" type="number" min="0" />
                </div>
                <div class="field">
                  <label>Coaching qty</label>
                  <input v-model.number="formProduct.coaching_quantity" type="number" min="0" />
                </div>

                <div class="field">
                  <label>Cons. Tecniche</label>
                  <input v-model.number="formProduct.cons_tecniche" type="number" min="0" />
                </div>

                <div class="field">
                  <label>Cons. Nutrizionali</label>
                  <input v-model.number="formProduct.cons_nutrizionali" type="number" min="0" />
                </div>


                <div class="field">
                  <label>PT qty</label>
                  <input v-model.number="formProduct.pt_quantity" type="number" min="0" />
                </div>
                <div class="field">
                  <label>Bonus PT</label>
                  <input v-model.number="formProduct.bonus_pt" type="number" min="0" />
                </div>
                <div class="field">
                  <label>Fonte</label>
                  <select v-model="formProduct.source">
                    <option value="manual">manual</option>
                    <option value="legacy">legacy</option>
                  </select>
                </div>
              </div>

              <div class="modal-actions">
                <button type="button" class="btn ghost staff-button-cancel" @click="closeForm">Annulla</button>
                <button type="submit" class="btn primary staff-button-positive" :disabled="saving">
                  {{ saving ? 'Salvataggio…' : 'Salva' }}
                </button>
              </div>

              <div v-if="errorMsg" class="error-msg">{{ errorMsg }}</div>
            </form>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import {
  getFirestore,
  collection,
  getDocs,
  query,
  addDoc,
  updateDoc,
  deleteDoc,
  doc,
} from "firebase/firestore";
import SidebarComponent from "../SidebarComponent.vue";

export default {
  name: "ProductList",
  components: { SidebarComponent },
  data() {
    return {
      products: [],
      currentAccordion: null,
      showForm: false,
      saving: false,
      errorMsg: "",
      formMode: "create", // 'create' | 'edit'
      formProduct: {},
      // filtri & sort
      search: "",
      categoryFilter: "",
      sortKey: "name",
      categories: [],
      defaultCategories: ["coaching-online", "Sedute Pt", "Integrazione", "Altro"],
    };
  },
  async created() {
    await this.fetchProducts();
  },
  computed: {
    filteredAndSorted() {
      let list = this.products;

      if (this.categoryFilter) {
        list = list.filter((p) => (p.category || "") === this.categoryFilter);
      }
      const term = this.search.trim().toLowerCase();
      if (term) {
        list = list.filter(
          (p) =>
            (p.name || "").toLowerCase().includes(term) ||
            (p.sku || "").toLowerCase().includes(term)
        );
      }

      const key = this.sortKey;
      list = [...list].sort((a, b) => {
        const av = a[key] ?? "";
        const bv = b[key] ?? "";
        if (key === "price") return (Number(bv) || 0) - (Number(av) || 0);
        if (key === "updatedAt") return new Date(bv) - new Date(av);
        return String(av).localeCompare(String(bv), "it", { sensitivity: "base" });
      });

      return list;
    },
    categoryOptions() {
      const dynamic = this.categories
        .filter((c) => c && !this.defaultCategories.includes(c))
        .sort((a, b) => a.localeCompare(b, "it", { sensitivity: "base" }));
      return [...this.defaultCategories, ...dynamic];
    },
  },
  methods: {
    async fetchProducts() {
      const db = getFirestore();
      const snap = await getDocs(query(collection(db, "products")));
      this.products = snap.docs.map((d) => ({ id: d.id, ...d.data() }));
      const set = new Set(this.products.map((p) => p.category).filter(Boolean));
      this.categories = Array.from(set).sort();
    },
    toggleAccordion(id) {
      this.currentAccordion = this.currentAccordion === id ? null : id;
    },
    openForm(mode, product = null) {
      this.errorMsg = "";
      this.formMode = mode;
      this.formProduct = product
        ? { ...product }
        : {
            name: "",
            sku: "",
            price: null,
            category: "coaching-online",
            duration_months: 0,
            program_count: 0,
            coaching_quantity: 0,
            pt_quantity: 0,
            bonus_pt: 0,
            source: "manual",
          };
      this.showForm = true;
    },
    closeForm() {
      this.showForm = false;
      this.formProduct = {};
    },
    async saveProduct() {
      if (!this.formProduct.name?.trim()) {
        this.errorMsg = "Il nome è obbligatorio";
        return;
      }
      try {
        this.saving = true;
        const db = getFirestore();
        const now = new Date().toISOString();

        if (this.formMode === "create") {
          await addDoc(collection(db, "products"), {
            ...this.formProduct,
            createdAt: now,
            updatedAt: now,
          });
        } else {
          const ref = doc(db, "products", this.formProduct.id);
          await updateDoc(ref, {
            ...this.formProduct,
            updatedAt: now,
          });
        }
        await this.fetchProducts();
        this.closeForm();
      } catch (e) {
        console.error(e);
        this.errorMsg = "Errore durante il salvataggio";
      } finally {
        this.saving = false;
      }
    },
    async deleteProduct(id) {
      if (!confirm("Vuoi davvero eliminare questo prodotto?")) return;
      try {
        const db = getFirestore();
        await deleteDoc(doc(db, "products", id));
        await this.fetchProducts();
      } catch (e) {
        console.error(e);
        alert("Errore durante l'eliminazione");
      }
    },
    formatPrice(v) {
      if (v === null || v === undefined || v === "") return "—";
      const n = Number(v);
      if (!Number.isFinite(n)) return "—";
      return n.toLocaleString("it-IT", { style: "currency", currency: "EUR" });
    },
    formatDate(s) {
      const d = new Date(s);
      if (isNaN(d)) return s || "—";
      return d.toLocaleString("it-IT");
    },
  },
};
</script>

<style scoped>
/* Toolbar */
.toolbar {
  display: flex;
  gap: 10px;
  margin: 12px 0 20px;
  flex-wrap: wrap;
}
.search,
.select {
  padding: 10px 12px;
  border-radius: 10px;
  border: 1px solid #dcdcdc;
  min-width: 220px;
  background: #fff;
}

/* Card */
.card-black-orders {
  background: #fff;
  border-radius: 12px;
  margin-bottom: 12px;
  border: 1px solid #e6e6e6;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04);
  overflow: hidden;
}
.card-header2 {
  display: grid;
  grid-template-columns: 40px 1fr auto 40px;
  align-items: center;
  gap: 10px;
  padding: 14px 12px;
  color: #1b1b1b;
  cursor: pointer;
  background: linear-gradient(180deg, #fafafa 0%, #f7f7f7 100%);
}
.icon-column,
.icon-column-right {
  display: flex;
  align-items: center;
  justify-content: center;
  color: #848484;
}
.header-text {
  font-weight: 700;
  font-size: 16px;
  color: #222;
}
.text-sub {
  margin-top: 4px;
  display: flex;
  gap: 8px;
  align-items: center;
  color: #666;
  font-size: 12px;
}
.price-column {
  text-align: right;
}
.price {
  font-weight: 700;
  color: #111;
}
.muted {
  color: #8a8a8a;
  font-size: 12px;
}
.badge {
  font-size: 11px;
  padding: 3px 8px;
  border-radius: 999px;
  border: 1px solid #e2e2e2;
  background: #f4f4f4;
  color: #444;
}
.badge-cat {
  background: #eef5ff;
  border-color: #d7e7ff;
  color: #2f5ea8;
}
.sku {
  font-size: 11px;
  color: #6a6a6a;
}

/* Dettagli */
.product-details {
  background: #fff;
  color: #222;
  padding: 14px;
  border-top: 1px solid #f0f0f0;
}
.grid {
  display: grid;
  gap: 10px;
  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
}
.kv {
  background: #fafafa;
  padding: 10px 12px;
  border-radius: 10px;
  border: 1px solid #ededed;
}
.k {
  display: block;
  font-size: 12px;
  color: #777;
  margin-bottom: 2px;
}
.v {
  font-weight: 700;
  color: #222;
}

/* Azioni */
.actions {
  display: flex;
  gap: 8px;
  margin-top: 12px;
}
.btn {
  padding: 8px 12px;
  border-radius: 8px;
  border: none;
  cursor: pointer;
}
.btn.ghost {
  background: #f1f1f1;
  color: #222;
}
.btn.ghost:hover {
  background: #e9e9e9;
}
.btn.primary {
  background: #2f6fec;
  color: #fff;
}
.btn.primary:hover {
  background: #255fd0;
}
.btn.danger {
  background: #e53935;
  color: #fff;
}
.btn.danger:hover {
  background: #c62828;
}


.dialog {
  background: #fff;
  width: min(900px, 92vw);
  border-radius: 14px;
  box-shadow: 0 24px 60px rgba(0, 0, 0, 0.25);
  padding: 18px;
}
.modal-title {
  margin: 4px 0 10px;
}
.form-grid {
  display: grid;
  gap: 10px;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
}
.field label {
  display: block;
  font-size: 12px;
  color: #555;
  margin-bottom: 6px;
}
.field input,
.field select {
  padding: 10px 12px;
  border: 1px solid #dedede;
  border-radius: 10px;
  background: #fff;
  color: #222;
}
.modal-actions {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  margin-top: 12px;
}
.error-msg {
  color: #b00020;
  margin-top: 8px;
}
</style>
